import styled from 'styled-components';

export const PreviewItem = styled.li`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    scroll-snap-align: start;
    scroll-snap-stop: always;
    flex-basis: 100%;
    list-style: none;
    margin: 0;
    width: 100%;
    height: 100%;
`;
